import { LinearProgress, useResourceContext } from "react-admin";
import { TowerRenderColumn } from "./TowerRenderColumn";
import { useQueryCached } from "../../ra-lb-tools/utils/useGetQueryCached";
import { getValidResource } from "../../ra-lb-tools/acl/tools";

export const TowerRenderByTowerId = ({ towerId, ...rest }) => {
  if (!towerId) return null;

  const resource = useResourceContext();

  const towerRequest = useQueryCached("getOne", resource, { id: towerId });
  const towerRequestData = towerRequest.data?.data;

  const lockerRequest = useQueryCached(
    "getList",
    getValidResource("lockers"),
    {
      sort: { field: "id", order: "ASC" },
      filter: { towerId },
      pagination: { page: 1, perPage: 1000 },
    },
    {
      cacheTimeout: 10,
    }
  );

  const towerModelRequest = useQueryCached(
    "getOne",
    getValidResource("tower-models"),
    { id: towerRequestData?.towerModelId },
    {
      enabled: !!towerRequestData?.towerModelId,
    }
  );

  if (
    towerRequest.isLoading ||
    lockerRequest.isLoading ||
    towerModelRequest.isLoading
  ) {
    return <LinearProgress />;
  }
  if (towerRequest.error) {
    return <p>ERROR: could not request tower #{towerId}</p>;
  }

  if (lockerRequest.error) {
    return <p>ERROR: could not request lockers for tower #{towerId}</p>;
  }

  if (towerModelRequest.error) {
    return <p>ERROR: could not load model #{towerRequestData?.towerModelId}</p>;
  }

  if (!towerRequestData?.towerModelId) {
    return (
      <p style={{ width: "200px" }}>
        Error: no tower model set for Tower {towerRequestData?.name} (#
        {towerRequestData?.id})
      </p>
    );
  }

  return (
    <TowerRenderWithData
      towerModel={towerModelRequest.data?.data}
      tower={towerRequestData}
      lockers={lockerRequest.data?.data}
      {...rest}
    />
  );
};

const TowerRenderWithData = ({ towerModel, tower, lockers, ...rest }) => {
  const specs = lockers.map((locker, index) =>
    Object.assign({}, towerModel.lockersSpec[index], locker)
  );

  const header = [
    `Tower '${tower.name}' (#${tower.id})`,
    `Model '${towerModel.name}' (#${towerModel.id})`,
  ];

  return (
    <TowerRenderColumn
      {...{
        tower,
        lockers: specs,
        numColumns: towerModel.numColumns,
        header: header,
        towerModel,
        ...rest,
      }}
    />
  );
};
